import React, { Component } from "react";

import { connect } from "react-redux";

import { Link } from "react-router-dom";

import { Header, Message, Button, Icon } from "semantic-ui-react";

import TransactionTable from "../../../components/TransactionTable";

import {
  transactionsRefreshed,
  refreshTransactions
} from "../../../actions/transactions";

class _RefreshButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refreshing: false,
      refreshResult: null,
      clearResultTimeout: null
    };
  }

  setResult = result => {
    const timeout = result === "ok" ? 1500 : 5000;
    const clearResultTimeout = setTimeout(() => {
      if (this.state.clearResultTimeout === clearResultTimeout) {
        this.setState({ refreshResult: null });
      }
    }, timeout);
    this.setState({
      refreshResult: result,
      clearResultTimeout: clearResultTimeout
    });
  };

  handleClick = () => {
    this.setState({
      refreshing: true
    });
    refreshTransactions()
      .then(result => {
        this.props.transactionsRefreshed(result);
        this.setResult("ok");
      })
      .catch(() => this.setResult("error"))
      .finally(() => {
        this.setState({
          refreshing: false
        });
      });
  };

  render() {
    return (
      <div>
        <Button
          style={{ marginRight: "1em" }}
          icon
          labelPosition="left"
          onClick={this.handleClick}
          disabled={this.state.refreshing}
          loading={this.state.refreshing}
        >
          <Icon name="sync" />Refresh Transactions
        </Button>
        {this.state.refreshResult === "ok" && (
          <span>
            <Icon name="check" color="green" /> Refreshed!
          </span>
        )}
        {this.state.refreshResult === "error" && (
          <span>
            <Icon name="times" color="red" /> Couldn't refresh. Please try
            again.
          </span>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  transactionsRefreshed: result => dispatch(transactionsRefreshed(result))
});

const RefreshButton = connect(
  null,
  mapDispatchToProps
)(_RefreshButton);

const RecentTransactionsView = props => {
  return (
    <div>
      {props.bankError && (
        <Message warning>
          <Message.Header>Connection Issue</Message.Header>
          <Message.Content>
            There{"'"}s a problem connecting to one or more of your bank
            accounts. No new transactions from that bank will appear here until
            it is resolved. Please resolve this issue in{" "}
            <Link href="/settings/banks">bank settings</Link>.
          </Message.Content>
        </Message>
      )}
      {props.waitingForTXs && (
        <Message info>
          <Message.Header>Waiting for Plaid</Message.Header>
          <Message.Content>
            A bank account you{"'"}ve connected is waiting to receive
            transaction data. Click refresh below to reload the data.
          </Message.Content>
        </Message>
      )}
      <RefreshButton />
      <Header dividing as="h3">
        <Header.Content>
          Pending transactions
          {
            // <Header.Subheader>
            //   Click on a transaction to see more.
            // </Header.Subheader>
          }
        </Header.Content>
      </Header>
      <TransactionTable
        transactions={props.pendingTransactions}
        emptyText="There are no pending transactions."
      />
      <Header dividing as="h3">
        <Header.Content>
          Posted transactions
          {
            // <Header.Subheader>
            //   Click on a transaction to see more.
            // </Header.Subheader>
          }
        </Header.Content>
      </Header>
      <TransactionTable transactions={props.transactions} />
    </div>
  );
};

const mapStateToProps = state => ({
  transactions: state.transactions.transactions,
  pendingTransactions: state.transactions.pending_transactions,
  bankError: state.transactions.bank_error,
  waitingForTXs: state.transactions.waiting_for_plaid
});

export default connect(mapStateToProps)(RecentTransactionsView);



// WEBPACK FOOTER //
// ./frontend/src/views/pages/transactions/RecentTransactionsView.js